/* /src/components/auth/silentRenew.js */
import { AuthConsumer } from "./authProvider";
import { LoadingIndicator } from "../components/common/VFX-UI";

const SilentRenew = () => (
  <AuthConsumer>
    {({ signinSilentCallback }) => {
      signinSilentCallback();
      return <LoadingIndicator />;
    }}
  </AuthConsumer>
);

export default SilentRenew;
